import { CommonApiFuncService } from '@anddone/ui-utilities';
import { inject, Injectable } from '@angular/core';
import { APIConstants } from '../constants/api.constant';
import { catchError, tap } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private commonAPIFuncService = inject(CommonApiFuncService);

  login(reqObj: any) {
    const endpoint = APIConstants.login.loginUser;
    const options = {
      customBaseUrl: environment.infraBaseUrl,
    };
    return this.commonAPIFuncService.post(endpoint, reqObj, options).pipe(
      tap((_) => this.commonAPIFuncService.log(`login success`)),
      catchError(this.commonAPIFuncService.handleError(`login error/failed`))
    );
  }

  forgotPassword(userName: string, reqObj: any) {
    const endpoint = APIConstants.forgotPassword.forgetPassword.replace('{userName}', userName);
    const options = {
      customBaseUrl: environment.infraBaseUrl,
    };
    return this.commonAPIFuncService.post(endpoint, reqObj, options).pipe(
      tap((_) => this.commonAPIFuncService.log(`forgotPassword success`)),
      catchError(this.commonAPIFuncService.handleError(`forgotPassword error/failed`))
    );
  }

  changePassword(reqObj: any) {
    const endpoint = APIConstants.changePassword.changePassword
      .replace('{allyId}', reqObj.allyId)
      .replace('{userName}', reqObj.userName);
    const newURL = encodeURI(endpoint);
    const options = {
      customBaseUrl: environment.infraBaseUrl,
    };
    return this.commonAPIFuncService.post(newURL, reqObj.data, options).pipe(
      tap((_a) => this.commonAPIFuncService.log(`changePassword success`)),
      catchError(this.commonAPIFuncService.handleError(`changePassword error/failed`))
    );
  }

  getloggedUsersDetails(reqObj: any) {
    const endpoint = APIConstants.user.getUserDetails.replace('{allyId}', reqObj.parentId);
    const options = {
      customBaseUrl: environment.domainBaseUrl,
    };
    return this.commonAPIFuncService.get(endpoint, options).pipe(
      tap((_) => this.commonAPIFuncService.log(`getloggedUsersDetails success`)),
      catchError(this.commonAPIFuncService.handleError(`getloggedUsersDetails error/failed`))
    );
  }

  logout() {
    const endpoint = APIConstants.login.logout;
    return this.commonAPIFuncService.delete(endpoint).pipe(
      tap((_) => this.commonAPIFuncService.log(`logout success`)),
      catchError(this.commonAPIFuncService.handleError(`logout error/failed`))
    );
  }
}
